<template>
  <div>
    <div class="flex items-center mb-4 justify-start space-x-2">
      <input
        placeholder="Customer Code"
        type="text"
        v-model="searchCustomerCode"
        class="border-2 rounded-sm px-2 py-1 border-solid border-gray-600"
      />
      <v-btn color="primary" @click="onSearchCustomerCode">Search</v-btn>
    </div>
    <v-data-table
      :headers="headers"
      :items="emails"
      :loading="loading"
      :search="search"
    >
      <template v-slot:[`item.email_match`]="{ item }">
        <span
          :class="
            item.email_match === 0
              ? 'bg-red-400'
              : 'bg-green-500 w-[500px] p-2 text-white rounded-full'
          "
        >
          {{ item.email_match === 1 ? "Ok" : "Mismatch" }}
        </span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn small color="orange" @click="openDialog(item)"
          ><v-icon>mdi-toolbox</v-icon></v-btn
        >
      </template>
    </v-data-table>

    <!-- New data table for email matches -->
    <v-data-table
      :headers="emailMatchesHeaders"
      :items="filteredEmailMatches"
      :loading="loadingEmailMatches"
    >
      <template v-slot:[`item.email`]="{ item }">
        <span>{{ item.email }}</span>
      </template>
      <template v-slot:[`item.match`]="{ item }">
        <span>{{ item.match }}</span>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogEmail"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <div class="bg-white">
        <div class="flex justify-end">
          <v-btn text @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="bg-white p-10">
          <div>
            <div class="mb-10">
              <div
                v-for="(value, key, i) in itemToMatch"
                :key="i"
                class="grid grid-cols-2 gap-2 px-4 py-1 text-sm"
              >
                <div class="bg-gray-300 p-2">
                  {{ key }}
                </div>
                <div class="bg-gray-300 p-2 break-words">
                  {{ value }}
                </div>
              </div>
            </div>
            <div
              class="space-x-4 flex items-center justify-center"
              v-if="!itemToMatch.email_match"
            >
              <v-btn @click="closeDialog">Cancel</v-btn>
              <v-btn @click="matchEmailNow(itemToMatch)"
                >Click to match email</v-btn
              >
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
    <DialogVue :message="message" :show="show" @close="close" />
  </div>
</template>

<script>
import axios from "axios";
import DialogVue from "../../components/Dialog.vue";
import moment from "moment-timezone"; // Import moment-timezone

export default {
  data() {
    return {
      show: false,
      message: "",
      searchCustomerCode: "",
      loading: false,
      loadingEmailMatches: false,
      itemToMatch: [],
      dialogEmail: false,
      emails: [],
      emailMatches: [], // New data property for email matches
      search: "",
      headers: [
        { text: "Email CSV", value: "email_csv" },
        { text: "Email System", value: "email_authuser" },
        { text: "Contract Number", value: "contract_number" },
        { text: "Customer Code", value: "customer_code" },
        { text: "Match", value: "email_match" },
        { text: "-", value: "action" },
      ],
      emailMatchesHeaders: [
        { text: "Customer Code", value: "customer_code" },
        { text: "Signed Up Email", value: "email_authuser" },
        { text: "CSV Email", value: "email_csv" },
        { text: "Match", value: "email_match" },
      ], // Headers for the new data table
    };
  },
  components: { DialogVue },
  computed: {
    filteredEmailMatches() {
      return this.emailMatches.filter(item => item.email_match === 0);
    }
  },
  methods: {
    close() {
      this.show = false;
    },
    async onSearchCustomerCode() {
      if (this.searchCustomerCode == "") {
        this.show = true;
        this.message = "Please fill in the customer code";
        return;
      }
      this.loading = true;
      try {
        const response = await axios.post("/users/getEmailMatches", {
          customer_code_new: this.searchCustomerCode,
        });
        if (response.data.status) {
          this.emails = response.data.data;
        }
      } catch (error) {
        console.error("Error searching customer code:", error);
      } finally {
        this.loading = false;
      }
    },
    openDialog(item) {
      this.dialogEmail = true;
      this.itemToMatch = item;
    },
    closeDialog() {
      this.dialogEmail = false;
      this.itemToMatch = [];
    },
    async matchEmailNow(item) {
      console.log("item.email_csv",item.email_csv, )
      console.log("item.user_id",item.user_id, )
      try {
        const response = await axios.post("/users/updateAuthUserEmail", {
          newEmail: item.email_csv,
          userId: item.user_id,
        });
        if (response.data.status) {
          this.closeDialog(); // Close the dialog on success
          this.onSearchCustomerCode(); // Refresh the email list
          alert(response.data.message);
        } else {
          this.show = true;
          this.message = response.data.message || "Failed to update email.";
        }
      } catch (error) {
        console.error("Error updating email:", error);
        
        // Extract the specific error message from the backend
        let errorMessage = "An error occurred while updating the email.";
        
        if (error.response && error.response.data) {
          // Check for the specific error details first
          if (error.response.data.details) {
            // Use the details field for specific error info
            errorMessage = error.response.data.details;
          } else if (error.response.data.error) {
            // Use the error field if details is not available
            errorMessage = error.response.data.error;
          } else if (error.response.data.message) {
            // Use the message field as fallback
            errorMessage = error.response.data.message;
          }
        } else if (error.message) {
          // Fallback to the error message
          errorMessage = error.message;
        }
        
        this.show = true;
        this.message = errorMessage;
      }
    },
    moment(date) {
      return moment.tz(date, "Asia/Manila").format("LLL"); // Adjust the timezone as needed
    },
    async getAllEmailMatches() {
      this.loadingEmailMatches = true;
      try {
        const response = await axios.get('/cs_data/email-matches');
        this.emailMatches = response.data.matches; // Store the matches in the new data property
      } catch (error) {
        console.error('Error fetching email matches:', error);
      } finally {
        this.loadingEmailMatches = false;
      }
    }
  },
  mounted() {
    // Call the function when the component is mounted
    this.getAllEmailMatches();
  }
};
</script>